import axios from "axios";
import { it } from "date-fns/locale";

const CreateWateringOperation = async (payload) => {
  const token = JSON.parse(localStorage.getItem("authentication"));
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const results = [];

  for (const item of payload) {
    try {
        console.log(item)
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/api/operation/CreateWateringOperation`,
        item,
        config
      );
      results.push({ status: 200, payload: data });
    } catch (error) {
      if (error.response) {
        results.push({
          status: error.response.status,
          payload: null,
          error: error.response.data,
        });
      } else {
        results.push({
          status: 500,
          payload: null,
          error: "Network or server error",
        });
      }
    }
  }

  return results; // ส่ง array ของผลลัพธ์ทั้งหมดกลับไป
};

export default CreateWateringOperation;
